import { Image, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IItemProps {
  text: string;
  picSrc?: string;
  number?: number;
}

export const Item: React.VFC<IItemProps> = ({ text, picSrc, number }) => {
  return (
    <div className={styles['item']}>
      {picSrc && (
        <div className={styles['item_img']}>
          <Image src={picSrc} alt="" />
        </div>
      )}
      {number && <div className={styles['number']}>{number}</div>}
      <UIText1>{text}</UIText1>
    </div>
  );
};
